/* !! DO NOT EDIT manually, this file is AUTO-GENERATED. Any edits to the file will be overwritten during the build. Edits should be made to the SVG with a matching name */ import * as React from "react";
const SvgBoldBulgarian = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 2048 2048",
        width: "1em",
        height: "1em",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M1284 128h376v1664h-376v-660q-110 60-228 93t-244 34q-125 0-221-29t-161-91-100-154-34-222V128h373v602q0 58 16 99t48 67 75 38 99 12q101 0 196-31t181-83V128z"
    }));
export default SvgBoldBulgarian;
